// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1IC8p","title":"AfterFrontImage_title__2Jheh"};